import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "", y = 36 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden pb-[0.12em] -mb-[0.12em] ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Chapter({ number, title, light = false }) {
  return (
    <Reveal className="flex items-center gap-4 mb-6">
      <span className={`font-display text-lg italic ${light ? "text-[#C5A059]" : "text-[#8B5A2B]"}`}>{number}</span>
      <span className="h-px w-10 bg-[#C5A059]" aria-hidden="true" />
      <span className={`eyebrow ${light ? "!text-[#C5A059]" : ""}`}>{title}</span>
    </Reveal>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-[#E0D8CC] bg-[#F2EDE4] py-5" data-testid="community-marquee">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-xl sm:text-2xl italic text-[#4A524C]">{item}</span>
            <span className="mx-8 text-[#C5A059] text-xs" aria-hidden="true">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
